// src/constants.ts
var LANGS = ["vi", "en"];
var DEFAULT_LANG = "vi";
var RANKS = ["junior", "mid", "senior"];
var ROLES = ["member", "sub_leader", "leader"];
var LEVELS = [1, 2, 3, 4, 5];
var REF_SCORE = { junior: 25, mid: 50, senior: 73 };
var L5_GOAL = { junior: 0, mid: 1, senior: 2 };
var FOCUS_MAX = 2;
var CONFIRM_UNDO_WINDOW_MS = 10 * 60 * 1e3;
var CONFIRMABLE_MIN_LEVEL = 3;
var COVERAGE_MIN_LEVEL = 4;
var COVERAGE_RISK_MAX = 1;
var UNCONFIRMED_COUNTS_AS = 2;
var TASK_NOTE_MIN_LENGTH = 10;
var TASK_NOTE_MAX_LENGTH = 1e3;
var TASK_NOTE_EXCERPT_LENGTH = 80;
var JOURNAL_MAX_LEN = 200;
var JOURNAL_MAX_PER_PERIOD = 30;
var NOTIFICATION_KINDS = [
  "period.opened",
  "period.midpoint",
  "period.ending",
  "period.overdue",
  "digest.weekly"
];
var REMIND_DAYS_BEFORE_END_DEFAULT = 3;
var NOTIFY_HOUR_DEFAULT = 9;
var TEAM_TIME_ZONE_DEFAULT = "Asia/Ho_Chi_Minh";

export {
  LANGS,
  DEFAULT_LANG,
  RANKS,
  ROLES,
  LEVELS,
  REF_SCORE,
  L5_GOAL,
  FOCUS_MAX,
  CONFIRM_UNDO_WINDOW_MS,
  CONFIRMABLE_MIN_LEVEL,
  COVERAGE_MIN_LEVEL,
  COVERAGE_RISK_MAX,
  UNCONFIRMED_COUNTS_AS,
  TASK_NOTE_MIN_LENGTH,
  TASK_NOTE_MAX_LENGTH,
  TASK_NOTE_EXCERPT_LENGTH,
  JOURNAL_MAX_LEN,
  JOURNAL_MAX_PER_PERIOD,
  NOTIFICATION_KINDS,
  REMIND_DAYS_BEFORE_END_DEFAULT,
  NOTIFY_HOUR_DEFAULT,
  TEAM_TIME_ZONE_DEFAULT
};
//# sourceMappingURL=chunk-XTNSOR45.js.map